(function () {
  'use strict';

  function init() {
    var isHome = document.body.classList.contains('template-index');

    if (isHome) {
      function adjustHero() {
        var headerGroup = document.querySelector('.shopify-section-group-header-group');
        var hero = document.querySelector('.mgn-hero');
        if (!headerGroup || !hero) return;
        var totalHeight = headerGroup.offsetHeight;
        hero.style.paddingTop = totalHeight + 'px';
      }
      adjustHero();
      window.addEventListener('resize', adjustHero);
      window.addEventListener('load', adjustHero);
    }

    var scrollThreshold = 60;
    function onScroll() {
      if (window.scrollY > scrollThreshold) {
        document.body.classList.add('mgn-scrolled');
      } else {
        document.body.classList.remove('mgn-scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
